import { Box, Button, DialogActions, Modal, Stack, Typography } from '@mui/material'
import React, { useContext } from 'react'
import { LanguageContext } from '../util/LanguageContext'
import {
  dialogCancelButtonSx,
} from '../constants/uiSx'

type ModalConfirmDialogDCPProps = {
  open: boolean
  text: string
  onClick: () => void
  buttonText?: string
  buttonStyle?: 'primary' | 'secondary'
}

export const ModalConfirmDialogDCP: React.FC<ModalConfirmDialogDCPProps> = props => {
  const { open, text, onClick, buttonText = 'button_next' } = props
  // 文字列変換用
  const translation = useContext(LanguageContext)

  const handleClose = (_: object, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') return
    onClick()
  }

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '31%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: 'auto',
          minHeight: '100px',
          width: '640px',
          bgcolor: 'background.paper',
          borderRadius: '10px',
          boxShadow: 16,
        }}
      >
        <Stack justifyContent="center" alignItems="center">
          <Typography
            sx={{
              mt: 4,
              mr: 2,
              ml: 2,
              mb: 2,
              color: '#282828',
              font: 'normal normal normal 1rem Noto Sans JP',
              wordWrap: 'break-word',
              textAlign: 'center',
            }}
          >
            {(translation[text] ?? text).split(/(。|、|\.)/).map((line, index, arr) => {
              if (index % 2 === 0) {
                // 偶数番目の要素はテキスト
                return (
                  <React.Fragment key={index}>
                    {line}
                    {index < arr.length - 1 && arr[index + 1]}
                    {(line.length > 0 || index < arr.length - 1) && <br />}
                  </React.Fragment>
                )
              }
              return null // 奇数番目の要素（分割文字）は無視する
            })}
          </Typography>
          <DialogActions>
            <Box mb="16px" display="flex" justifyContent="center">
              <Button
                type="submit"
                onClick={onClick}
                sx={dialogCancelButtonSx}
              >
                {translation[buttonText] ?? buttonText}
              </Button>
            </Box>
          </DialogActions>
        </Stack>
      </Box>
    </Modal>
  )
}
